import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal, state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import { t } from '@billes/translator-client'

export default connect(
  {
    client: state`app.client.name`,
    showTerms: state`startPage.showTerms`,
    onCloseTerms: signal`startPage.onCloseTerms`
  },
  class Detail extends Component {
    render() {
      const { showTerms, client, onCloseTerms } = this.props
      if (!showTerms) {
        return null
      }

      return (
        <div className={css(styles.termsBackground)}>
          <div className={css(styles.termsContainer)}>
            <h3 className={css(styles.headline)}>
              {t('bms.terms.headline', { client: client })}
            </h3>
            <p
              dangerouslySetInnerHTML={{
                __html: t('bms.terms.text', {
                  client: `${client}`,
                  url: window.location.href
                })
              }}
            />
            <button
              className={css(styles.button)}
              onClick={e => {
                onCloseTerms()
              }}
            >
              {t('bms.terms.agree')}
            </button>
          </div>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/StartPage/Terms/terms.js